import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import SidebarPanel from './SidebarPanel';

const Cess = (props) => {
    let cess = props.cess;
    return(
        <ul className="item-total listview image-listview"> 
            <li>
                <div className="item font-size-13 font-weg-300">
                    <div className="in">
                        <div className="item-name font-weg-400"> CESS </div>
                        <div className="item-qty"> {(parseFloat(cess.PERC))}% </div>
                        <span className="badge badge-light font-size-13 font-weg-400">&#8377; {cess.VALUE}</span>
                    </div>
                </div>
            </li>
        </ul>
    );
}

const CessCharges = (props) => {
    return (
        props.cessItems.map(post2 => {
            let cess2 = post2[1];
            return( <Cess key={post2} cess={cess2} />);
        })
    );    
}

const Tax = (props) => {
    let tax = props.tax;
    return( 
        <ul className="item-total listview image-listview">
            <li>
                <div className="item font-size-13 font-weg-300">
                    <div className="in">
                        <div className="item-name font-weg-400"> SGST </div>
                        <div className="item-qty"> {(parseFloat(tax.PERC))/2}% </div>
                        <span className="badge badge-light font-size-13 font-weg-400">&#8377; {tax.SGST}</span>
                    </div>
                </div>
            </li>
            <li>
                <div className="item font-size-13 font-weg-300">
                    <div className="in">
                        <div className="item-name font-weg-400"> CGST </div>
                        <div className="item-qty"> {(parseFloat(tax.PERC))/2}% </div>
                        <span className="badge badge-light font-size-13 font-weg-400">&#8377; {tax.CGST}</span>
                    </div>
                </div>
            </li>
        </ul>
    );
}

const TaxCharges = (props) => {
    return (
        props.taxItems.map(post2 => {
            let tax2 = post2[1];
            return( <Tax key={post2} tax={tax2} />);
        })
    );    
}


class Checkout extends React.Component {
    constructor(props) {
        //console.log(props);
        super(props);
        this.state = {
            LOADING: true, 
            LOCATION: this.props.location.pathname,
            instructions: localStorage.getItem('vegONLY') || '',
            ITEMS: [],
            CartCount: 0,
            CustomerAddress: '',
            r_minthreshold: 0,
            overRIDE: '',
            restaurant_allowed: '',
            delApplicable: '',
            itemtax_charges: [],
            itemcess_charges: [],
            delivery_charges: [],
            conveyance_charges: [],
            coupon_discount: 0,
            coupon_discountTEXT: '',
            payMODE: '',
            CUSTOMER_DET: '',
            DEL_DATE: '',
            DEL_TIME: '',
            ADDITIONAL_DISCOUNT: '',
            ADDITIONAL_DISCOUNT2: 0,
            ADDITIONAL_TEXT:''
        };
    }

    fetchCustomerProfile(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/profile_api2.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                            
            that.setState({ LOADING:false, CUSTOMER_DET:CUSTOMER_DET  });
        });
    }

    fetchCheckoutItems(mode,items,customer,address_id,offer_id,offer_code) {
        var id = localStorage.getItem('delCIRCLE');
        
        var that = this;
        fetch('https://m.donedelivery.in/api/checkoutitems_api.php?mode='+mode+'&id='+id+'&items='+items+'&customer='+customer+'&address_id='+address_id+'&offer_id='+offer_id+'&offer_code='+offer_code,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            let customer_address = result.address;
            if(customer_address=='' || customer_address==undefined)
                customer_address = '';

            let address_id = result.address_id;
            if(address_id=='' || address_id==undefined)
                address_id = '';

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
                    
            if(customer_address!='' && address_id!='')
                localStorage.setItem('addressID', address_id)
            that.setState({ LOADING:false, ITEMS:result.ITEMS, CustomerAddress:customer_address, r_minthreshold: result.r_minthreshold, overRIDE: result.overRIDE, restaurant_allowed: result.restaurant_allowed, delApplicable: result.delApplicable, itemtax_charges: result.tax, itemcess_charges: result.cess, delivery_charges: result.delivery_charges, conveyance_charges: result.conveyance_charges, coupon_discount:result.discount, coupon_discountTEXT:result.discount2, CUSTOMER_DET:CUSTOMER_DET, DEL_DATE:result.DEL_DATE, DEL_TIME:result.DEL_TIME, ADDITIONAL_DISCOUNT:result.ADDITIONAL_DISCOUNT, ADDITIONAL_DISCOUNT2:result.ADDITIONAL_DISCOUNT2, ADDITIONAL_TEXT:result.ADDITIONAL_TEXT });
        });
    }

    handleClickAddressMissing = () =>{
        $('#ModalAddressMissing').modal('show');
    }

    handlePayModeChecked = (e,payMode) => {
        e.preventDefault();
        localStorage.setItem('payMode', payMode);
        this.setState({payMODE: payMode});
    }    
    
    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');

        let address_id = '';
        if(localStorage.getItem('addressID'))
            address_id = localStorage.getItem('addressID');
    
        let itemLIST = '';
        let cart = localStorage.getItem('cartData');
        let cartData = JSON.parse(cart);
        if(cart !== null && cart!=='{}')
        {
            Object.keys(cartData).forEach(function(key) {
                let cart_id = key.split('~~**~~');
                let itemID = cart_id[0];
                let itemCOUNT = cartData[key];
                itemLIST += itemID+'|'+itemCOUNT+',';
            });    
        }

        if(itemLIST!='')
            itemLIST = itemLIST.substring(0, itemLIST.length-1);
                
        let OFFER_APPLIED = localStorage.getItem('OFFER_APPLIED');
        if(OFFER_APPLIED==null) 
            OFFER_APPLIED = '';
            
        let offerID = '';
        let offerAPPLIED = '';
        if(OFFER_APPLIED!='')
        {
            let OFFER_APPLIED2 =  OFFER_APPLIED.split('~~**~~');
            offerID =  OFFER_APPLIED2[0];
            offerAPPLIED =  OFFER_APPLIED2[1];
        }

        this.fetchCheckoutItems('ITEMS',itemLIST,customer,address_id,offerID,offerAPPLIED);
    }

    render() { 
        let logged = 'N';
        if(localStorage.getItem('userData'))
            logged = 'Y';

        if (logged=='N')
        {
            if(localStorage.getItem('cartData'))
                return (<Redirect to={'/cart'}/>)
            else
                return (<Redirect to={'/home'}/>)
        }

        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/cart';
        let AppHeaderTitle = 'Order Review';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        let cart = localStorage.getItem('cartData');
        let cartData = JSON.parse(cart);

        if(cart !== null && cart!=='{}')
        {
            let LIST = this.state.ITEMS;
            Object.keys(cartData).forEach(function(key) {
                let cart_id = key.split('~~**~~');

                if(LIST.length>0)
                {
                    LIST.map(id =>{

                        if(cart_id[0]==id.ITEMID)
                        {
                            //if(id.NEXTAVAILABLE!='')
                            if(id.AVAILABLE_QTY==='0' || id.AVAILABLE_QTY===0)
                            {
                                delete cartData[key];
                            }
                        }
                    });
                }
            });

            localStorage.setItem('cartData', JSON.stringify(cartData));
        }

        cart = localStorage.getItem('cartData');
        cartData = JSON.parse(cart);
        let cartItemCount = 0;
        let cartEMPTY = 'Y';

        if(cart !== null && cart!=='{}')
        {
            cartEMPTY = 'N';
            Object.keys(cartData).forEach(function(key) {

                let itemCOUNT = cartData[key];
                cartItemCount = cartItemCount + itemCOUNT;
            });
        }
        
        if (cartEMPTY=='Y') {
		    return (<Redirect to={'/home'}/>)
		}

        let props = {
            items: this.state.ITEMS,
            updateCart: this.updateCart
        };

        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
            else
                Verified = 'N';
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        if(this.state.payMODE!='')
        {
            return (<Redirect to={'/submit_order'}/>);
        }

        let address_id = '';
        if(localStorage.getItem('addressID'))
            address_id = localStorage.getItem('addressID');

        let cartTOTAL = 0;
        let cartSUBTOTAL = 0;
        let itemtax_charges = this.state.itemtax_charges;
        let itemcess_charges = this.state.itemcess_charges;

        Object.keys(itemtax_charges).forEach(function(key) {
            let tax = itemtax_charges[key];
            cartTOTAL = parseFloat(cartTOTAL) + parseFloat(tax.VALUE);
        });

        Object.keys(itemcess_charges).forEach(function(key) {
            let cess = itemcess_charges[key];
            cartTOTAL = parseFloat(cartTOTAL) + parseFloat(cess.VALUE);
        });
        
        if(this.state.delApplicable=='D')
        {
            cartTOTAL = parseFloat(cartTOTAL) + parseFloat(this.state.delivery_charges.CHARGES) + parseFloat(this.state.delivery_charges.SGST) + parseFloat(this.state.delivery_charges.CGST) + parseFloat(this.state.delivery_charges.IGST);
        }
        else if(this.state.delApplicable=='C')
        {
            cartTOTAL = parseFloat(cartTOTAL) + parseFloat(this.state.conveyance_charges.CHARGES) + parseFloat(this.state.conveyance_charges.SGST) + parseFloat(this.state.conveyance_charges.CGST) + parseFloat(this.state.conveyance_charges.IGST);
        }
        
        if(this.state.coupon_discount>0)
            cartTOTAL = parseFloat(cartTOTAL) - parseFloat(this.state.coupon_discount)
        
        if(this.state.ADDITIONAL_DISCOUNT2!=0 && this.state.ADDITIONAL_DISCOUNT2!=undefined && this.state.ADDITIONAL_DISCOUNT2>0)
            cartTOTAL = parseFloat(cartTOTAL) - parseFloat(this.state.ADDITIONAL_DISCOUNT2)

        var taxItems = Object.keys(itemtax_charges).map(function(key) {
            return [key, itemtax_charges[key]];
        });
    
        var cessItems = Object.keys(itemcess_charges).map(function(key) {
            return [key, itemcess_charges[key]];
        });

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="section full mt-2 pb-4">
                        <div className="section inset pt-0 pb-1">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card p-2">
                                        <div className="content-header pb-05 pr-0 pl-0 font-size-13 text-dgrey font-weg-500">Delivery Address:</div>
                                        <div className="section-title w-100  d-flex justify-content-between pt-0 pb-0 pr-0 pl-0">
                                            {this.state.CustomerAddress!='' && <p className="mb-0 pt-05 w-70 text-mgrey font-size-11"><strong className="font-weg-600 text-black">{this.state.CustomerAddress.LABEL}</strong> {this.state.CustomerAddress.ADDRESS} {this.state.CustomerAddress.ADDRESS2} {this.state.CustomerAddress.ADDRESS3} {this.state.CustomerAddress.MOBILE }</p>}
                                            <span>
                                                {this.state.CustomerAddress!='' && <Link to="/changeaddress" className="btn text-upper newshadowed font-size-12 square btn-danger btn-sm btn-block">Change</Link>}
                                                {this.state.CustomerAddress=='' && <Link to="/addaddress" className="btn text-upper newshadowed font-size-12 square btn-danger btn-sm btn-block">Add</Link>}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cart-list-items pb-5">
                            <ul className="item-title listview image-listview">
                                <li>
                                    <div className="item font-size-14 font-weg-400">
                                        <div className="in">
                                            <div className="item-name"> Item </div>
                                            <div className="item-qty"> Qty </div>
                                            <span className="badge badge-light font-size-14 font-weg-400">Price</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="listview image-listview">
                                {
                                this.state.ITEMS.map(item=>{
                                    let cartCount = 0; //this.state.cartCount;

                                    let currentITEM = item.ID;
                                    let cart = localStorage.getItem('cartData');
                                    if (cart !== null) {
                                        let cartData = JSON.parse(cart);
                                        Object.keys(cartData).forEach(function(key) {
                                            let id = key.split('~~**~~');
                                            if(id[0]==currentITEM)  
                                                cartCount += cartData[key];
                                        });
                                    }

                                    let itemTOTAL = parseFloat(item.RATE) * parseFloat(cartCount);
                                    cartSUBTOTAL = parseFloat(cartSUBTOTAL) + parseFloat(itemTOTAL);
                                    cartTOTAL = parseFloat(cartTOTAL) + parseFloat(itemTOTAL);
                                    
                                    if(cartCount>0)
                                    {
                                        return (
                                            <li key={item.ID}>
                                                <div className="item">
                                                    <div className="in">
                                                        <div className="item-name font-size-12 text-sdgrey font-weg-400">{item.NAME} ( per {item.UNIT})</div>
                                                        <div className="font-size-12 font-weg-400">
                                                            <span className="text-danger">&#8377; {item.RATE}</span> x {cartCount}
                                                        </div>
                                                        <span className="badge badge-light font-size-14 font-weg-400">&#8377; {itemTOTAL.toFixed(2)}</span>
                                                    </div>
                                                </div>
                                            </li>
                                        );
                                    }
                                })}
                            </ul>
                            <ul className="item-total listview image-listview">
                                <li>
                                    <div className="item font-size-14 font-weg-400">
                                        <div className="in">
                                            <div className="item-name font-weg-500"> Subtotal </div>
                                            <span className="badge badge-light font-size-14 font-weg-400">&#8377; {cartSUBTOTAL.toFixed(2)}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            {taxItems!='' && <TaxCharges taxItems={taxItems} />}
                            {cessItems!='' && <CessCharges cessItems={cessItems} />}
                                {this.state.coupon_discount!=0 &&
                                    <ul className="item-total listview image-listview">
                                        <li>
                                            <div className="item pt-06 pb-06 font-size-14 font-weg-400">
                                                <div className="in">
                                                    <div className="item-name text-warning"> Coupon Discount </div>
                                                    <span className="badge badge-light font-size-14 font-weg-400 text-warning">-&#8377; {this.state.coupon_discount.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                }
                                {this.state.coupon_discountTEXT!=0 &&
                                    <ul className="item-total listview image-listview">
                                        <li>
                                            <div className="item pt-06 pb-06 font-size-14 font-weg-400">
                                                <div className="in">
                                                    <div className="item-name text-warning" style={{'width':'100%'}}> Free {this.state.coupon_discountTEXT} </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                }
                                {this.state.ADDITIONAL_DISCOUNT2!=0 && this.state.ADDITIONAL_DISCOUNT2!=undefined &&
                                    <ul className="item-total listview image-listview">
                                        <li>
                                            <div className="item pt-06 pb-06 font-size-14 font-weg-400">
                                                <div className="in">
                                                    <div className="item-name text-warning"> {this.state.ADDITIONAL_TEXT} </div>
                                                    <span className="badge badge-light font-size-14 font-weg-400 text-warning">-&#8377; {this.state.ADDITIONAL_DISCOUNT2.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                }
                                {console.log(this.state.ADDITIONAL_DISCOUNT)}
                                {this.state.ADDITIONAL_DISCOUNT!='' && this.state.ADDITIONAL_DISCOUNT!=undefined &&
                                    <ul className="item-total listview image-listview">
                                        <li>
                                            <div className="item pt-06 pb-06 font-size-14 font-weg-400">
                                                <div className="in">
                                                    <div className="item-name text-warning" style={{'width':'100%'}}> {this.state.ADDITIONAL_TEXT}: {this.state.ADDITIONAL_DISCOUNT} </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                }
                                {this.state.delApplicable=='D' &&
                                    <ul className="item-total listview image-listview">
                                        <li>
                                            <div className="item pt-06 pb-06 font-size-14 font-weg-400">
                                                <div className="in">
                                                    <div className="item-name font-weg-500"> Delivery Charges </div>
                                                    <span className="badge badge-light font-size-14 font-weg-400">&#8377; {this.state.delivery_charges.CHARGES.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </li>
                                        {this.state.delivery_charges.SGST!=0 && <li>
                                            <div className="item font-size-13 font-weg-300">
                                                <div className="in">
                                                    <div className="item-name font-weg-400"> SGST </div>
                                                    <div className="item-qty"> {(parseFloat(this.state.delivery_charges.PERC))/2}% </div>
                                                    <span className="badge badge-light font-size-13 font-weg-400">&#8377; {this.state.delivery_charges.SGST.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </li>}
                                        {this.state.delivery_charges.CGST!=0 && <li>
                                            <div className="item font-size-13 font-weg-300">
                                                <div className="in">
                                                    <div className="item-name font-weg-400"> CGST </div>
                                                    <div className="item-qty"> {(parseFloat(this.state.delivery_charges.PERC))/2}% </div>
                                                    <span className="badge badge-light font-size-13 font-weg-400">&#8377; {this.state.delivery_charges.CGST.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </li>}
                                        {this.state.delivery_charges.IGST!=0 && <li>
                                            <div className="item font-size-13 font-weg-300">
                                                <div className="in">
                                                    <div className="item-name font-weg-400"> IGST </div>
                                                    <div className="item-qty"> {(parseFloat(this.state.delivery_charges.PERC))/2}% </div>
                                                    <span className="badge badge-light font-size-13 font-weg-400">&#8377; {this.state.delivery_charges.IGST.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </li>}
                                    </ul>
                                }
                                {this.state.delApplicable=='C' &&
                                    <ul className="item-total listview image-listview">
                                        <li>
                                            <div className="item pt-06 pb-06 font-size-14 font-weg-400">
                                                <div className="in">
                                                    <div className="item-name font-weg-500"> Delivery Charges </div>
                                                    <span className="badge badge-light font-size-14 font-weg-400">&#8377; {this.state.conveyance_charges.CHARGES.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </li>
                                        {this.state.conveyance_charges.SGST!=0 && <li>
                                            <div className="item font-size-13 font-weg-300">
                                                <div className="in">
                                                    <div className="item-name font-weg-400"> SGST </div>
                                                    <div className="item-qty"> {(parseFloat(this.state.conveyance_charges.PERC))/2}% </div>
                                                    <span className="badge badge-light font-size-13 font-weg-400">&#8377; {this.state.conveyance_charges.SGST.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </li>}
                                        {this.state.conveyance_charges.CGST!=0 && <li>
                                            <div className="item font-size-13 font-weg-300">
                                                <div className="in">
                                                    <div className="item-name font-weg-400"> CGST </div>
                                                    <div className="item-qty"> {(parseFloat(this.state.conveyance_charges.PERC))/2}% </div>
                                                    <span className="badge badge-light font-size-13 font-weg-400">&#8377; {this.state.conveyance_charges.CGST.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </li>}
                                        {this.state.conveyance_charges.IGST!=0 && <li>
                                            <div className="item font-size-13 font-weg-300">
                                                <div className="in">
                                                    <div className="item-name font-weg-400"> IGST </div>
                                                    <div className="item-qty"> {(parseFloat(this.state.conveyance_charges.PERC))/2}% </div>
                                                    <span className="badge badge-light font-size-13 font-weg-400">&#8377; {this.state.conveyance_charges.IGST.toFixed(2)}</span>
                                                </div>
                                            </div>
                                        </li>}
                                    </ul>
                                }
                                {this.state.delApplicable=='' &&
                                    <ul className="item-total listview image-listview">
                                        <li>
                                            <div className="item pt-06 pb-06 font-size-14 font-weg-400">
                                                <div className="in">
                                                    <div className="item-name"> Delivery Charges </div>
                                                    <span className="badge badge-light font-size-14 font-weg-400">FREE</span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                }
                        </div>
                        <div>
                            <div className="delivery-date date-slot">
                                <p className="font-size-12 pt-1 font-weg-500 mt-2 mb-0 pr-2 pl-2">Delivery Date</p>
                                <div className="form-group basic more-locations pt-05">
                                    <div className="input-wrapper">
                                        <p className="form-control text-upper btn  bg-white square custom-select" id="city4">{this.state.DEL_DATE}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="delivery-date time-slot">
                                <p className="font-size-12 pt-1 font-weg-500 mt-2 mb-0 pr-2 pl-2">Delivery Time</p>
                                <div className="form-group basic more-locations pt-05">
                                    <div className="input-wrapper">
                                        <p className="form-control text-upper btn  bg-white square custom-select" id="city4">{this.state.DEL_TIME}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="clear"></div>
                        </div>
                        <div className="form-button-group2">
                            <div className="col-12">
                                <div className="section-title w-100  d-flex justify-content-between pt-1 pb-1 pr-0 pl-0 medium"> Total 
                                    <span>&#8377; {cartTOTAL.toFixed(2)}</span>
                                </div>
                            </div>
                        </div>
                        <div className="form-button-group1 pr-2 pl-2">
                            <div className="col-12">
                                <div className="text-upper">
                                    <div className="row">
                                        <div className="col-6">
                                            <Link to="/categories" className="btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-ssm btn-block goBack">Add more items</Link>
                                        </div>
                                        <div className="col-6">
                                            {address_id=='' && <Link to="#" data-toggle="modal" data-target="#ModalAddressMissing" className="btn newshadowed font-size-14 square btn-danger btn-ssm btn-block" onClick={props.handleClickAddressMissing}>PAY NOW</Link>}
                                            {address_id!='' && <Link to="#" data-toggle="modal" data-target="#DialogIconedInfo" className="btn newshadowed font-size-14 square btn-danger btn-ssm btn-block">PAY NOW</Link>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal pay-modal fade dialogbox" id="DialogIconedInfo" data-backdrop="static" tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title font-size-13 font-weg-500">Choose a payment option</h5>
                                <Link to="#" className="btn close-btn" data-dismiss="modal">x</Link>
                            </div>
                        <div className="modal-body mt-3">
                            <button type="submit" className="mb-2 lt-space1 text-upper btn btn-danger btn-block square">
                                <Link className="text-upper btn-danger" to="#" onClick={(e)=>{this.handlePayModeChecked(e,2)}}>Online Payment</Link>
                            </button>
                            <button type="submit" className="lt-space1 text-upper btn btn-dark btn-block square">
                                <Link className="text-upper btn-dark" to="#" onClick={(e)=>{this.handlePayModeChecked(e,1)}}>Cash on Delivery</Link>
                            </button>
                            <div>
                                <p>
                                    <div className="item pt-06 pb-06 font-size-14 font-weg-400 text-center">Delivery Date: {this.state.DEL_DATE}<br />{this.state.DEL_TIME}</div>
                                </p>
                                <p>
                                    <div className="item font-size-11 font-weg-400 red">Products are subject to availability due to ongoing restrictions</div>
                                </p>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade dialogbox" id="ModalAddressMissing" data-backdrop="static" tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-icon text-danger">
                                <ion-icon name="close-circle"></ion-icon>
                            </div>
                            <div className="modal-body">
                                <p className="if-no-add">Please add delivery address</p> 
                            </div>
                            <div className="modal-footer">
                                <div className="btn-inline"> 
                                    <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
  
export default Checkout;


// WEBPACK FOOTER //
// ./src/components/Checkout.js